import { useUserActivity } from '@/hooks/use-user-activity';
import { Box, Container } from '@chakra-ui/react';
import { FC } from 'react';
import ActivityFilters from '../Activity/ActivityFilters';
import { ActivityTable } from '../Activity/ActivityTable';
import { formatSelectedFilters, useActivityFilters } from '../Activity/utils';

type Props = {
  address: string;
};

export const AccountActivity: FC<Props> = ({ address }) => {
  const { selectedFilters, toggleFilter } = useActivityFilters();

  const response = useUserActivity(
    address,
    ...(selectedFilters.length ? [{ types: formatSelectedFilters(selectedFilters) }] : []),
  );

  return (
    <Box pt="space.12" pb="space.24">
      <Container variant="breakout">
        <ActivityFilters
          address={address}
          data={response.data}
          refetch={response.refetch}
          isRefetching={response.isRefetching}
          selectedFilters={selectedFilters}
          onFilterToggle={toggleFilter}
          withRefreshButton
        />
        <ActivityTable activityResponse={response} />
      </Container>
    </Box>
  );
};
